import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import noop from 'lodash/noop';
import find from 'lodash/find';
import SelectField from '../../../shared/form-elements/select/field';

const Table = ({
	table,
	intl,
	sortByColumn,
	showMoreRows,
	remove,
	refererTypeOptions,
	updateRefererType,
	pagination,
	gotoPage,
	can
}) => (
	<div className="table-container defined-referers-table">
		<table className="simple-table">
			<thead className="simple-table__head font-roboto-medium">
				<tr>
					{ table.headers.map((header, i) => (
						<th
							key={i}
							className={cn({
								'sort-header': header.direction,
								'active': table.sortedColumn.index === header.index,
								[header.className]: header.className,
								[table.sortedColumn.direction]: (
									table.sortedColumn.index === header.index && table.sortedColumn.direction
								)
							})}
							onClick={() => header.direction ? sortByColumn(header.index) : noop}>{intl(header.title)}</th>
					))}
				</tr>
			</thead>

			<tbody className="simple-table__body">
				{ table.rows.map((row, i) => (
					<tr key={i}>
						<td className="domain"><span>{ row.title ? `${row.domain} (${row.title})` : row.domain }</span></td>
						<td className="referer"><span>{ row.referer }</span></td>
						<td className="type">
							<SelectField
								name="type"
								placeholder="Type"
								searchable={false}
								value={getFromOptions(refererTypeOptions, row.type)}
								options={refererTypeOptions}
								meta={{}}
								onChange={val => updateRefererType(val, row)}
								showLabel={false}
								disabled={!can('edit')}
							/>
						</td>
					</tr>
				)) }
			</tbody>
		</table>

		<div className="table-container__pagination">
			<div className="table-container__pagination-items">
				{pagination.pages.map(pageIndex => {
					const page = ++pageIndex;
					return (
						<a
							key={page}
							href="#"
							className={cn({
								'table-container__pagination-item': true,
								active: page === pagination.currentPage
							})}
							onClick={e => {
								e.preventDefault();
								gotoPage(page);
							}}
						>
							{page}
						</a>
					);
				})}
			</div>
		</div>
	</div>
);

Table.propTypes = {
	table: PropTypes.object,
	pagination: PropTypes.object,
	gotoPage: PropTypes.func,
	refererTypeOptions: PropTypes.array,
	updateRefererType: PropTypes.func,
	intl: PropTypes.func,
	sortByColumn: PropTypes.func,
	showMoreRows: PropTypes.func,
	remove: PropTypes.func,
	can: PropTypes.func
};

export default Table;

const getFromOptions = (options, value) => {
	const val = find(options, { value });
	return val ? [val] : null;
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/defined-referers/components/table/main.js